import { useQuery } from "relay-hooks";
import { graphql } from "babel-plugin-relay/macro";
import { useGetState } from "../../components/ReduxProvider";
import { canShowOAuth } from "../../tools/device";
import { PreLoginQuery } from "root/auth/__generated__/PreLoginQuery.graphql";

const query = graphql`
  query PreLoginQuery($deviceId: String!, $newsletterId: String) {
    preLogin(deviceId: $deviceId, newsletterId: $newsletterId) {
      token
      email
      prefillType
      prefillEmail
      users {
        email
        flamesCount
        loginMethod
        lastLoginAt
        subscription
      }
    }
  }
`;

export const usePreLoginQuery = (deviceIdOverride?: string, newsletterId?: string | null) => {
  const reduxDeviceId = useGetState("deviceId");
  const deviceId: string = deviceIdOverride ?? (reduxDeviceId || "");
  const { data, isLoading } = useQuery<PreLoginQuery>(
    query,
    { deviceId, newsletterId },
    { skip: (!deviceId && !newsletterId) || !canShowOAuth() }
  );
  return { data: data?.preLogin, isLoading };
};
